interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "PHP";
};

const PHP: Currency = Object.freeze({
  "displayName": "Philippine Peso",
  "numericCode": 608,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "PHP",
  "symbol": "₱"
});

export { PHP };
